/**
 * @generated SignedSource<<d77a8b66c12ddab3ba49d583bea28ad7>>
 * @relayHash a615654a08ce3274fc54e07efd9211ea
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e5addd49b9ac727e4192ce3ec103b6837173e48788768fc87bc51109c51864cf

import type { ConcreteRequest } from 'relay-runtime';
export type preloadCreateSpaceQuery$variables = Record<PropertyKey, never>;
export type preloadCreateSpaceQuery$data = {
  readonly user: {
    readonly confluence: {
      readonly operations: ReadonlyArray<{
        readonly operation: string | null | undefined;
      } | null | undefined>;
    } | null | undefined;
    readonly id: string | null | undefined;
  } | null | undefined;
};
export type preloadCreateSpaceQuery = {
  response: preloadCreateSpaceQuery$data;
  variables: preloadCreateSpaceQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": "user",
    "args": [
      {
        "kind": "Literal",
        "name": "current",
        "value": true
      }
    ],
    "concreteType": "AtlassianUser",
    "kind": "LinkedField",
    "name": "confluence_atlassianUser",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "id"
      },
      {
        "concreteType": "ConfluenceUser",
        "kind": "LinkedField",
        "name": "confluence",
        "plural": false,
        "selections": [
          {
            "concreteType": "OperationCheckResult",
            "kind": "LinkedField",
            "name": "operations",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "operation"
              }
            ]
          }
        ]
      }
    ],
    "storageKey": "confluence_atlassianUser(current:true)"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "preloadCreateSpaceQuery",
    "selections": (v0/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "preloadCreateSpaceQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "a615654a08ce3274fc54e07efd9211ea",
    "id": "e5addd49b9ac727e4192ce3ec103b6837173e48788768fc87bc51109c51864cf",
    "metadata": {},
    "name": "preloadCreateSpaceQuery",
    "operationKind": "query",
    "text": "query preloadCreateSpaceQuery{user:confluence_atlassianUser(current:true){id,confluence{operations{operation}}}}"
  }
};
})();

(node as any).hash = "9a716c385cdfcba90204a7cf16292b9a";

export default node;
